import React, { useState } from 'react';
import { Accordion, Card, Modal } from "react-bootstrap";
import MinimizeIcon from "@material-ui/icons/Minimize";
import AddIcon from "@material-ui/icons/Add";
import CloseIcon from "@material-ui/icons/Close";

import {
  CardHeader,
  ModalObservation,
  ObservationMobile,
  ObservationDesktop,
  AddIconStyles,
  MinimizeIconStyles,
  ObservationContent
} from "./styles";
import { InfoButton } from "~/components/layout/Buttons";

export default function ObservationComponent({
  modalObservationActive,
  desktopObservationActive,
  addObservation,
  date,
  items,
  observation
}) {

  const [writingTextArea, setWritingTextarea] = useState("")

  return(
    <>
      <Modal
        show={modalObservationActive(true)}
        onHide={() => {
          modalObservationActive();
        }}
        className="modal-observation"
        centered
      >
        <Modal.Body>
          <ModalObservation>
            <div>
              <h4>Observações</h4>
              <CloseIcon
                style={{ color: "#000FFF" }}
                onClick={() => modalObservationActive()}
              />
            </div>
            <textarea
              maxLength="255"
              placeholder="Descreva aqui..."
              onChange={(e) => setWritingTextarea(e.target.value)}
            >
              {observation !== "Nenhuma observação" ? observation : ""}
            </textarea>
            <InfoButton
              margin={"1rem 0 0 0"}
              onClick={() => {
                addObservation(writingTextArea);
                modalObservationActive();
              }}
            >
              Salvar
            </InfoButton>
          </ModalObservation>
        </Modal.Body>
      </Modal>
      <ObservationDesktop>
        {date !== "" && items.length > 0 ? (
          <Accordion style={{ margin: "0 0 1.5rem 0" }}>
            <Card.Header
              style={CardHeader}
              onClick={() => desktopObservationActive()}
            >
              Observações
              {desktopObservationActive(true) ? (
                <MinimizeIcon
                  style={MinimizeIconStyles}
                />
              ) : (
                <AddIcon
                  style={AddIconStyles}
                />
              )}
            </Card.Header>
            <Card>
              {desktopObservationActive(true) ? (
                <ModalObservation>
                  <textarea
                    maxLength="255"
                    placeholder="Descreva aqui..."
                    onChange={(e) =>
                      setWritingTextarea(e.target.value)
                    }
                  >
                    {observation !== "Nenhuma observação"
                      ? observation
                      : ""}
                  </textarea>
                  <InfoButton
                    margin={"1rem 0 0 0"}
                    onClick={() => {
                      addObservation(writingTextArea);
                      desktopObservationActive();
                    }}
                  >
                    Salvar
                  </InfoButton>
                </ModalObservation>
              ) : (
                <ObservationContent>
                  {observation === ""
                    ? "Nenhuma observação"
                    : observation.length > 50
                    ? observation.substring(0, 50) + "..."
                    : observation.substring(0, 50)}
                </ObservationContent>
              )}
            </Card>
          </Accordion>
        ) : null}
      </ObservationDesktop>
      <ObservationMobile>
        {date !== "" && items.length > 0 ? (
          <Accordion
            style={{ margin: "0 0 1.5rem 0" }}
            onClick={() => modalObservationActive()}
          >
            <Card.Header style={CardHeader}>
              Observações
              <AddIcon
                style={AddIconStyles}
              />
            </Card.Header>
            <Card>
              <ObservationContent>
                {observation === ""
                    ? "Nenhuma observação"
                    : observation.length > 50
                    ? observation.substring(0, 50) + "..."
                    : observation.substring(0, 50)}
              </ObservationContent>
            </Card>
          </Accordion>
        ) : null}
      </ObservationMobile>
    </>
  );
}
